module.exports = __webpack_public_path__ + "img/left-side-menu-site-settings-active.3d31274f.svg";